import { API_BASE_URL } from '../../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../../lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

export const fetchDocumentTypes = async ({ limit = 10, offset = 1, query = {}, sort } = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/document-types/filter`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ limit, offset, query, sort }),
  });
  return res.json();
};

export const listAllDocumentTypes = async () => {
  // Lista plana sin paginar, para alimentar selects / pickers.
  const res = await apiFetch(`${API_BASE_URL}/document-types`, { headers: withTenant() });
  return res.json();
};

export const createDocumentType = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/document-types`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateDocumentType = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/document-types/${id}`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteDocumentType = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/document-types/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};

export const toggleDocumentTypeStatus = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/document-types/${id}/toggle-status`, {
    method: 'POST',
    headers: JSON_HEADERS,
  });
  return res.json();
};

export const exportDocumentTypes = async ({ query = {}, sort } = {}) => {
  return fetchDocumentTypes({ limit: 10000, offset: 1, query, sort });
};
